import script from "./ManageBillingV4.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageBillingV4.vue?vue&type=script&setup=true&lang=js"

import "./ManageBillingV4.vue?vue&type=style&index=0&id=4dda3371&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dda3371"]])

export default __exports__